<template>

	<div class="form-group">

		<label for="week">{{ label }}</label>

		<div :class="{ 'input-group': group }">

			<div class="input-group-addon" v-if="group">
				<i class="fa fa-calendar-o" aria-hidden="true"></i>
			</div>

			<select id="week" class="form-control" v-model="week" :required="required" :disabled="disabled" @change="changed">
				<option value="" v-if="showFirst" v-translate>Selecione uma semana</option>
				<option v-for="week in weeks" :value="week">
					{{ week.startDate | date('DD/MM/YYYY') }}
					<span>à</span>
					{{ week.endDate | date('DD/MM/YYYY') }}
				</option>
			</select>

		</div>

	</div>

</template>

<script>

	import Week from './';
	export default Week;

</script>



// WEBPACK FOOTER //
// main.vue?adddc866